export default __webpack_public_path__ + "static/media/PsychologyToday-logo.20178890.png";